import html2pdf from "html2pdf.js";
// import LogoMittsure from "../newLogo2204.PNG";
import LogoMittsure from '../logoForOrder.png';

const OlympiadClubbingPdf = (data) => {

    console.log("Generating PDF with data:", data);

    if (!data) return;

    // =========================
    // Financial Year
    // =========================
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;

    let fyStartYear;
    let fyEndYear;

    if (month >= 4) {
        fyStartYear = year;
        fyEndYear = year + 1;
    } else {
        fyStartYear = year - 1;
        fyEndYear = year;
    }

    const fiscalYearRange = `${fyStartYear}-${String(fyEndYear).slice(-2)}`;

    // =========================
    // Helpers
    // =========================
    const safe = (val) => {
        return val !== undefined &&
            val !== null &&
            val !== ""
            ? val
            : "N/A";
    };

    const currency = (val) => {
        return `₹${Number(val || 0).toLocaleString("en-IN")}`;
    };

    const formatDate = (date) => {

        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    // =========================
    // Dynamic Subject Map
    // =========================
    const subjectMap = {
        science: "Science",
        maths: "Maths",
        mathsmatics: "Maths",
        english: "English",
        reasoning: "Reasoning",
        "gk_iq": "GK & IQ",
        gk: "GK & IQ",
        iq: "GK & IQ"
    };

    // =========================
    // Registration Data
    // =========================
    const registrations = data?.registrations || [];

    // =========================
    // Student Summary
    // =========================
    const studentSummary = {};

    registrations.forEach((reg) => {

        (reg?.allRegistrationLineItemes || []).forEach((item) => {

            const className = item?.class_name || "N/A";
            // const subjectName = (item?.subject_name || "").toLowerCase();
            const subjectName = (item?.subject_name || "").trim().toLowerCase();
            if (!studentSummary[className]) {
                studentSummary[className] = {
                    class: className,
                    subjects: {}
                };
            }

            // studentSummary[className].subjects[subjectName] =
            //     Number(item?.student || 0);
            studentSummary[className].subjects[subjectName] =
                (studentSummary[className].subjects[subjectName] || 0) +
                Number(item?.student || 0);
        });
    });

    // =========================
    // Study Material Summary
    // =========================
    const studySummary = {};

    registrations.forEach((reg) => {

        (reg?.allRegistrationLineItemes || []).forEach((item) => {

            const className = item?.class_name || "N/A";
            // const subjectName = (item?.subject_name || "").toLowerCase();
            const subjectName = (item?.subject_name || "").trim().toLowerCase();

            if (!studySummary[className]) {
                studySummary[className] = {
                    class: className,
                    subjects: {}
                };
            }

            // studySummary[className].subjects[subjectName] =
            //     Number(item?.study_material || 0);
            studySummary[className].subjects[subjectName] =
                (studySummary[className].subjects[subjectName] || 0) +
                Number(item?.study_material || 0);
        });
    });

    // =========================
    // Get All Subjects Dynamically
    // =========================
    const allSubjects = new Set();

    registrations.forEach((reg) => {

        (reg?.allRegistrationLineItemes || []).forEach((item) => {

            if (item?.subject_name) {
                // allSubjects.add(item.subject_name);
                allSubjects.add(item.subject_name?.trim());
            }
        });
    });

    const subjectList = [...allSubjects];

    // =========================
    // Sort Class
    // =========================
    const sortByClass = (a, b) => {

        const getClassNumber = (cls) =>
            parseInt(String(cls || "").replace(/[^0-9]/g, "")) || 0;

        return getClassNumber(a.class) - getClassNumber(b.class);
    };

    // =========================
    // Student Rows
    // =========================
    const studentRows = Object.values(studentSummary)
        ?.sort(sortByClass)
        ?.map((row) => {
               const rowTotal = Object.values(row?.subjects || {}).reduce(
            (sum, val) => sum + Number(val || 0),
            0
        );

            return `
                <tr>
                    <td style="padding:6px;">
                        ${safe(row?.class)}
                    </td>

                    ${subjectList.map((subject) => {

                const val =
                    // row?.subjects?.[subject.toLowerCase()] || 0;
                    row?.subjects?.[subject?.trim()?.toLowerCase()] || 0

                return `
                            <td style="padding:6px; text-align:center;">
                                ${val}
                            </td>
                        `;
            }).join("")}
            <td style="padding:6px; text-align:center; font-weight:bold;">
                    ${rowTotal}
                </td>
                </tr>
            `;
        })
        ?.join("");

    // =========================
    // Study Rows
    // =========================
    const studyRows = Object.values(studySummary)
        ?.sort(sortByClass)
        ?.map((row) => {
               const rowTotal = Object.values(row?.subjects || {}).reduce(
            (sum, val) => sum + Number(val || 0),
            0
        );

            return `
                <tr>
                    <td style="padding:6px;">
                        ${safe(row?.class)}
                    </td>

                    ${subjectList.map((subject) => {

                const val =
                    // row?.subjects?.[subject.toLowerCase()] || 0;
                    row?.subjects?.[subject?.trim()?.toLowerCase()] || 0

                return `
                            <td style="padding:6px; text-align:center;">
                                ${val}
                            </td>
                        `;
                    }).join("")}
             <td style="padding:6px; text-align:center;">
        ${rowTotal}
    </td>
                </tr>
            `;
        })
        ?.join("");

    // =========================
    // Transactions
    // =========================
    const transactionRows = registrations
        ?.flatMap((reg) => reg?.AllTransactions || [])
        ?.map((txn, index) => {

            return `
                <tr>
                    <td style="padding:6px;">
                        ${index + 1}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.transactionReference)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.payment_mode)}
                    </td>

                    <td style="padding:6px;">
                        ${formatDate(txn?.transactionDate)}
                    </td>

                    <td style="padding:6px;">
                        ${currency(txn?.paidAmount)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.transactionStatus)}
                    </td>
                </tr>
            `;
        })
        ?.join("");

    // =========================
    // Coordinator Rows
    // =========================
    const coordinatorRows = data?.overAllCordinators
        ?.map((item, index) => {

            return `
                <tr>
                    <td style="padding:6px;">
                        ${index + 1}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.subId == "9999" ? "General Coordinator" : item?.subject)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.name)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.mobile)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(item?.role)}
                    </td>
                </tr>
            `;
        })
        ?.join("");

    const totalStudents = Object.values(studentSummary).reduce(
        (acc, row) => {
            const rowTotal = Object.values(row.subjects || {}).reduce(
                (sum, val) => sum + Number(val || 0),
                0
            );

            return acc + rowTotal;
        },
        0
    );
    
    const totalStudyMaterial = Object.values(studySummary).reduce(
        (acc, row) => {
            const rowTotal = Object.values(row.subjects || {}).reduce(
                (sum, val) => sum + Number(val || 0),
                0
            );

            return acc + rowTotal;
        },
        0
    );

    // =========================
    // HTML
    // =========================
    const htmlContent = `
        <div style="padding:15px; font-family:Arial; color:#000; font-size:12px;">

            <!-- HEADER -->
            <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:15px;">

                <img
                    src="${LogoMittsure}"
                    style="width:150px; object-fit:contain;"
                />

                <div style="text-align:right;">
                    <p style="margin-top:5px;">
                        <b>Party ID:</b> ${safe(data?.partyId)}
                    </p>
                </div>
            </div>

            <!-- TITLE -->
            <h3 style="text-align:center; margin:0; color:#000; font-weight:600;">
                Mittsure Technologies LLP
            </h3>

            <h4 style="text-align:center; margin:5px 0 20px 0; color:#000; font-weight:600;">
                Olympiad Registration Summary (${fiscalYearRange})
            </h4>

            <!-- SCHOOL INFO -->
            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <td style="padding:6px;">
                        <b>School Name:</b>
                        ${safe(data?.schoolName)} ${data?.partyId ? ` - (${data?.partyId})` : ''}
                    </td>

                    <td style="padding:6px;">
                        <b>Total Registrations:</b>
                        ${safe(data?.totalRegistrations)}
                    </td>
                </tr>

                <tr>
                    <td style="padding:6px;">
                        <b>Total Students:</b>
                        ${safe(data?.overAllStudents)}
                    </td>

                    <td style="padding:6px;">
                        <b>Total Study Material:</b>
                        ${safe(data?.overAllStudyMaterial)}
                    </td>
                </tr>

                <tr>
                    <td style="padding:6px;">
                        <b>Total Paid:</b>
                        ${currency(data?.overAllPaid)}
                    </td>

                    <td style="padding:6px;">
                        <b>Total Pending:</b>
                        ${currency(data?.overAllPending)}
                    </td>
                </tr>
                 <tr>
                    <td style="padding:6px;">
                        <b>Olympiad Date:</b>
                        ${formatDate(data?.registrations[0]?.exam_date)}
                    </td>

                     <td style="padding:6px;">
                        <b>School Email:</b>
                        ${safe(data?.schoolEmail)}
                    </td>
                </tr>

            </table>

            <!-- STUDENT SUMMARY -->
            <h4 style="margin-bottom:5px; color:#000; font-weight:600;">
                Student Registration Summary
            </h4>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th  style="padding:6px; background:#dce3dd; color:#000;">Class</th>

                    ${subjectList.map((subject) => `
                        <th  style="padding:6px; background:#dce3dd; color:#000;">
                            ${subject}
                        </th>
                    `).join("")}
                    <th  style="padding:6px; background:#dce3dd; color:#000;">Total</th>
                </tr>

                ${studentRows || `
    <tr>
        <td colspan="${subjectList.length + 1}"
            style="padding:10px; text-align:center; color:#000; font-weight:600;">
            No Data Available
        </td>
    </tr>
`}

<tr style="background:#dce3dd; font-weight:bold;">
    <td style="padding:6px;">
        Total
    </td>

    ${subjectList.map((subject) => {

        const subjectTotal = Object.values(studentSummary).reduce(
            (sum, row) =>
                sum +
                Number(
                    row?.subjects?.[
                    subject?.trim()?.toLowerCase()
                    ] || 0
                ),
            0
        );

        return `
            <td style="padding:6px; text-align:center;">
                ${subjectTotal}
            </td>
        `;
    }).join("")}
      <td style="padding:6px; text-align:center;">
        ${totalStudents}
    </td>
</tr>
            </table>

            <!-- STUDY MATERIAL -->
            <h4 style="margin-bottom:5px; color:#000; font-weight:600;">
                Study Material Summary
            </h4>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th  style="padding:6px; background:#dce3dd; color:#000;">Class</th>

                    ${subjectList.map((subject) => `
                        <th  style="padding:6px; background:#dce3dd; color:#000;">
                            ${subject}
                        </th>
                    `).join("")}
                    <th  style="padding:6px; background:#dce3dd; color:#000;">Total</th>
                </tr>

                ${studyRows || `
    <tr>
        <td colspan="${subjectList.length + 1}"
            style="padding:10px; text-align:center; color:#000; font-weight:600;">
            No Data Available
        </td>
    </tr>
`}

<tr style="background:#dce3dd; font-weight:bold;">
    <td style="padding:6px;">
        Total
    </td>

    ${subjectList.map((subject) => {

        const subjectTotal = Object.values(studySummary).reduce(
            (sum, row) =>
                sum +
                Number(
                    row?.subjects?.[
                    subject?.trim()?.toLowerCase()
                    ] || 0
                ),
            0
        );

        return `
            <td style="padding:6px; text-align:center;">
                ${subjectTotal}
            </td>
        `;
    }).join("")}
     <td style="padding:6px; text-align:center;">
        ${totalStudyMaterial}
    </td>
</tr>
            </table>

            <!-- PAYMENT SUMMARY -->
            <h4 style="margin-bottom:5px; color:#000; font-weight:600;">
                Payment Summary
            </h4>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Total Amount</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Paid Amount</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Pending Amount</th>
                </tr>

                <tr>
                    <td style="padding:6px;">
                        ${currency(data?.overAllAmount)}
                    </td>

                    <td style="padding:6px;">
                        ${currency(data?.overAllPaid)}
                    </td>

                    <td style="padding:6px;">
                        ${currency(data?.overAllPending)}
                    </td>
                </tr>

            </table>

            <!-- TRANSACTION SUMMARY -->
            <h4 style="margin-bottom:5px; color:#000; font-weight:600;">
                Transaction Details
            </h4>

            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;">

                <tr>
                    <th style="padding:6px; background:#dce3dd; color:#000;">#</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Reference No.</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Payment Mode</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Date</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Amount</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Status</th>
                </tr>

                ${transactionRows || `
                    <tr>
                        <td colspan="6"
                            style="padding:10px; text-align:center; color:#000; font-weight:600;">
                            No Transactions Available
                        </td>
                    </tr>
                `}
            </table>

            <!-- COORDINATOR -->
            <h4 style="margin-bottom:5px; color:#000; font-weight:600;">
                Coordinators
            </h4>

            <table border="1" style="width:100%; border-collapse:collapse;">

                <tr>
                    <th style="padding:6px; background:#dce3dd; color:#000;">#</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Subject</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Name</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Mobile</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Role</th>
                </tr>

                ${coordinatorRows || `
                    <tr>
                        <td colspan="5"
                            style="padding:10px; text-align:center; color:#000; font-weight:600;">
                            No Coordinators Available
                        </td>
                    </tr>
                `}
            </table>

        </div>
    `;

    // =========================
    // Generate PDF
    // =========================
    const element = document.createElement("div");

    element.innerHTML = htmlContent;

    // html2pdf()
    //     .set({
    //         margin: 5,
    //         filename: `Olympiad_${safe(data?.partyId)}.pdf`,
    //         image: {
    //             type: "jpeg",
    //             quality: 1
    //         },
    //         html2canvas: {
    //             scale: 2,
    //             useCORS: true
    //         },
    //         jsPDF: {
    //             unit: "mm",
    //             format: "a4",
    //             orientation: "portrait"
    //         }
    //     })
    //     .from(element)
    //     .save();
    const options = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: 'Order_form.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, logging: true, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' }
      };
      html2pdf()
        .set(options)
        .from(element)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
  
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(0, 0, 0);
  
            pdf.text(
              `Page ${i} of ${totalPages}`,
              pageWidth - 1.5,
              pageHeight - 0.3
            );
          }
        })
        .save(data?.partyId ? `Olympiad_${safe(data?.partyId)}.pdf` : 'Olympiad_Summary.pdf')
        .then(() => {
          document.body.removeChild(element);
        });
};

export default OlympiadClubbingPdf;